export let Provider = /*#__PURE__*/function (Provider) {
  Provider["PROVIDER_UNKNOWN"] = "PROVIDER_UNKNOWN";
  Provider["GOOGLE"] = "GOOGLE";
  Provider["MICROSOFT"] = "MICROSOFT";
  Provider["ICLOUD"] = "ICLOUD";
  return Provider;
}({});
export let SortOrder = /*#__PURE__*/function (SortOrder) {
  SortOrder["ASC"] = "ASC";
  SortOrder["DESC"] = "DESC";
  return SortOrder;
}({});
//# sourceMappingURL=types.js.map